<template>


    <section> 
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2">
                <b-img src="img/custom/springer.png" fluid />
              </b-col>
              <b-col md="6" class="order-md-1">
                <div class="pr-md-5">
                  
                    <h1>
                            It's up to you
                        </h1>
                        <p v-if="(currentSnapWizard.format == 'a4')">
                            
                            While no financial investment is required from the artist, the success of
this project relies heavily on your creative involvement, commitment of
time, book promotion, and dedication leading up to and during the
launch. To ensure the project’s viability, with your help, we aim to reach
at least 25 copies during the pre-order phase, which will help establish
a solid foundation and demonstrate demand.

                        </p>
                        <p v-if="(currentSnapWizard.format == '30x30')">
                            
                            While no financial investment is required from the artist, the success of
this project relies heavily on your creative involvement, commitment of
time, book promotion, and dedication leading up to and during the
launch. To ensure the project’s viability, with your help, we aim to reach
at least 50 copies during the pre-order phase, which will help establish
a solid foundation and demonstrate demand.

                        </p>

                        <b-form-radio-group v-model="currentSnapWizard.marketing_comfy">
                        <div>
                            <b-form-radio value="1" name="unchecked" class="mb-3">
                                Yes, I am prepared to do that
                            </b-form-radio>
                        </div>
                        <div>
                            <b-form-radio value="0" name="checked" class="mb-3">
                                No
                            </b-form-radio>
                        </div>
                    </b-form-radio-group>
                    
                    
                        <p v-if="show_sorry">We understand your decision, and we regret to inform you that we cannot continue our collaboration without your active participation in marketing the book. However, if you choose to promote your book in the future, please do not hesitate to reach out to us. We would be more than happy to explore the possibility of working together again.</p>

                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>
    
    
    
    
    
    
    
    </template>
    
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'

export default {
    name: 'snap09',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
            //this.currentSnapWizard.marketing_comfy == 1 && (this.currentSnapWizard.source != "" && this.currentSnapWizard.source != undefined)
            if (
                this.currentSnapWizard.marketing_comfy == 1
            ) {
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.$emit('showFooterNav');
                return true;
            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
        show_sorry() {
            if(this.currentSnapWizard.marketing_comfy == 0 || this.currentSnapWizard.marketing_comfy == "" ){
                this.$emit('denyProceed');
                return true;
            }
            else{
                return false;
            }
        },
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.allDataValidated();
    }
};
</script>